import { useLingui } from "@lingui/react";
import { t } from "@lingui/macro";
import { Languages } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { AVAILABLE_LOCALES, loadLocale, type Locale } from "@/lib/i18n";

const NATIVE_NAMES: Record<Locale, string> = {
  en: "English",
  de: "Deutsch",
  es: "Español",
  fr: "Français",
  it: "Italiano",
  pt: "Português",
};

export function LanguageSwitcher() {
  const { i18n } = useLingui();
  const current = (AVAILABLE_LOCALES as readonly string[]).includes(i18n.locale)
    ? (i18n.locale as Locale)
    : "en";

  return (
    <Select value={current} onValueChange={(v) => loadLocale(v as Locale)}>
      <SelectTrigger className="w-[140px]" aria-label={t({ id: "auth.language.label", message: "Language" })}>
        <Languages className="h-4 w-4 mr-2" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {AVAILABLE_LOCALES.map((locale) => (
          <SelectItem key={locale} value={locale}>
            {NATIVE_NAMES[locale]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
